import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class CapsuleExchangeFlow extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onInputChange = this.onInputChange.bind(this);

    // privates
    this._node = this;
    this._url_refill_code = false;
    this._refill_code = this.querySelector('.refill-code');
    this._form = this._node.querySelector('form');
    this._email_input = this._node.querySelector('input[type="email"]');
    this._email_val = this._email_input.value.trim();
    this._submit_btn = this._node.querySelector('.submit-btn');
    this._error = this._node.querySelector('.cef-error');
    this._product_id = this._node.getAttribute('data-pid') ? parseInt(this._node.getAttribute('data-pid'), 10) : false;
    this._selling_plan_id = this._node.getAttribute('data-sid') ? parseInt(this._node.getAttribute('data-sid'), 10) : false;
    this._swiper_el = this._node.querySelector('.steps-swiper');
    this._pagination = this._node.querySelector(".pagination");

    // events
    if (this._swiper_el) {
      this._swiper = new Swiper(this._swiper_el, {
        a11y: false,
        speed: 333,
        loop: false,
        draggable: true,
        autoHeight: true,
        slidesPerView: 'auto',
        watchOverflow: true,
        pagination: {
          el: this._pagination,
          clickable: true
        },
        keyboard: {
          enabled: false
        }
      });
    }

    // events
    this._form.addEventListener('submit', this.onFormSubmit);
    this._email_input.addEventListener('input', this.onInputChange);

    setTimeout(() => {
      this.checkSearchParams();
    }, 1000);
  }

  checkSearchParams() {
    let params = new URLSearchParams(document.location.search),
        afrc = params.get("_afrpc");

    if (afrc) {
      this._url_refill_code = afrc;
      this._refill_code.classList.remove('--loading');
      this._refill_code.innerText = afrc;

      if (this._email_val !== '') {
        this._submit_btn.classList.remove('--disabled');
      }
    }
  }

  onInputChange() {
    this._email_val = this._email_input.value.trim();

    if (!this._email_val.includes('@') || !this._email_val.includes('.')) {
      this._submit_btn.classList.add('--disabled');
    } else {
      this._submit_btn.classList.remove('--disabled');
    }
  }

  onFormSubmit(e) {
    e.preventDefault();
    document.activeElement.blur();

    if (this._submit_btn.classList.contains('--disabled')) {
      return false;
    }

    if (this._email_val !== '' && this._product_id) {
      let items = [],
          product_data = {
            id: this._product_id,
            quantity: 1,
            properties: {
              "Refill Code": this._url_refill_code ? this._url_refill_code : ""
            }
          };

      if (this._selling_plan_id) {
        product_data['selling_plan'] = this._selling_plan_id;
      }

      this._submit_btn.classList.add('--sending');
      items.push(product_data);
      this.checkCart(items);
    }
  }

  async checkCart(items) {
    const cart_res = await fetch("/cart.js");
    const cart_json = await cart_res.json();
    let cart_items = cart_json.items;

    if (cart_items.length > 0) {
      this.emptyCart(items);
    } else {
      this.addToCart(items);
    }
  }

  emptyCart(items) {
    fetch("/cart/clear.js", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      if (!response.ok) {
        console.log(response);
      } else {
        return response.json();
      }
    })
    .then((response) => {
      if (response) {
        this.addToCart(items);
      }
    })
  }

  async addToCart(items) {
    fetch("/cart/add.js", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({items})
    })
    .then((response) => {
      if (!response.ok) {
        console.log(response);
        let error = "An error occured! Please try again later.";
        this.updateProductError(error);
      } else {
        return response.json();
      }
    })
    .then((response) => {
      if (response) {
        this.goToCheckout();
      }
    })
  }

  goToCheckout() {
    let url = this._email_val !== '' ? `/checkout?checkout[email]=${this._email_val}` : '/checkout';
    window.location.href = url;
  }

  updateProductError(error) {
    this._submit_btn.classList.remove('--sending');

    if (error) {
      this._error.querySelector('p').innerText = error;
      this._error.style.display = "block";
    } else {
      this._error.querySelector('p').innerText = "";
      this._error.style.display = "none";
    }
  }

  /**
   * Handle unmount.
   */
  disconnectedCallback() {
    this._form.removeEventListener('submit', this.onFormSubmit);
    this._email_input.removeEventListener('input', this.onInputChange);
  }
}
